import { render, staticRenderFns } from "./AddEditSubEventDetails.vue?vue&type=template&id=1d283c3c"
import script from "./AddEditSubEventDetails.vue?vue&type=script&lang=js"
export * from "./AddEditSubEventDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports